<template>
  <div id="classroom-stats-component">
    <div class="vx-row my-2">
      <div class="vx-col w-full lg:w-2/3 mb-base">
        <!-- <vx-card
          class="overflow-hidden">
          <div slot="no-body">
            <div>Classroom Stats</div>
          </div>
        </vx-card> -->
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-base">
        <TotalStudent :updating="updating.totalStudent" v-bind="totalStudent" />
      </div>
    </div>
    
    <div class="vx-row my-2">
      <div class="vx-col w-full">
        <StudentInEachUnit :updating="updating.classroomStats" :chartSeries="studentInEachUnit.series" :chartOptions="studentInEachUnit.options.chartOptions" />
      </div>
    </div>
    
    <div class="vx-row my-2">
      <div class="vx-col w-full">
        <StudentAccessHeatmap :updating="updating.classroomStats" :chartSeries="studentAccessHeatmap.series" :chartOptions="studentAccessHeatmap.options.chartOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import { state } from "./data.js";

export default {
  components: {
    TotalStudent: () => import("./subcomponents/TotalStudent.vue"),
    StudentInEachUnit: () => import("./subcomponents/StudentInEachUnit.vue"),
    StudentAccessHeatmap: () => import("./subcomponents/StudentAccessHeatmap.vue"),
  },
  props: {
    dev: {
      type: Boolean,
      default: false
    },
    devData: {
      type: Object,
      default: null
    },
    classroomId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      updating: {
        totalStudent: true,
        classroomStats: true,
      },
      totalStudent: state.totalStudent,
      studentInEachUnit: state.studentInEachUnitSeries,
      studentAccessHeatmap: state.studentAccessHeatmap,
    }
  },
  methods: {
    async getTotalStudentData() {
      this.updating.totalStudent = true;
      if (this.dev && this.devData) {
        this.totalStudent = this.devData.totalStudent;
      }

      const classroom = await this.$store.dispatch("ClassroomStats/getClassroom", { id: this.classroomId });

      if (classroom) {
        if (this.classroomId === classroom.id) {
          this.totalStudent.total = classroom.studentRegisterQty;
        }
      }
      this.updating.totalStudent = false;
    },
    async getClassroomStats() {
      this.updating.classroomStats = true;
      const { status, data } = await this.$store.dispatch("ClassroomStats/getClassroomStats", { id: this.classroomId })

      if (status.success) {
        this.studentInEachUnit.series = data.seriesTotalStudentInEachUnits;
        this.studentAccessHeatmap.series = data.seriesStudentAccess;
      }
      this.updating.classroomStats = false;
    },
    async getClassroomStudentInEachUnitData() {
      const series = await this.$store.dispatch("ClassroomStats/getClassroomStudentInEachUnitStats", { id: this.classroomId })

      if (series) {
        this.studentInEachUnit.series = series;
      }
    }
  },
  async beforeMount() {
    await this.getTotalStudentData();
    await this.getClassroomStats();
  },
}
</script>
